import { IPaginatedREST, ISupervisor } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const listSupervisors = async (): Promise<IPaginatedREST<ISupervisor>> => {
    const qs = new URLSearchParams({}).toString()

    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.supervisors}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createSupervisor = async (data: Pick<ISupervisor, 'name'>): Promise<ISupervisor> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.supervisors}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
